import { render, staticRenderFns } from "./DetailedCheck.vue?vue&type=template&id=e2d3323e&scoped=true"
import script from "./DetailedCheck.vue?vue&type=script&lang=js"
export * from "./DetailedCheck.vue?vue&type=script&lang=js"
import style0 from "./DetailedCheck.vue?vue&type=style&index=0&id=e2d3323e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d3323e",
  null
  
)

export default component.exports